import store from '../store'
import axiosCore from "axios";
export default class ApiBioTime {
  static async getInstance(typeSdk) {
    if (!ApiBioTime.instance) {
      const app = await store.getters.getFirebaseApp;
      const BioTimeConfSnap = await app.database.queryBuilder("BIO/Activos/"+typeSdk);
      //Assert_1.StrictAssert.ok(BioTimeConfSnap.exists(), Model_1.ErrorInModel("ApiBioTime", null, "No existe la configuracion para el api de biotime"));
      const BioTimeConf = BioTimeConfSnap.val();
      ApiBioTime.instance = axiosCore.default.create({
        baseURL: BioTimeConf.URL,
        headers: { "Content-Type": "application/json" },
      });
      ApiBioTime.instance.interceptors.request.use(async function (config) {
        if (!config.headers["Authorization"]) {
          const tokenRes = await ApiBioTime.instance.post("Auth/login", { username: BioTimeConf.user, password: BioTimeConf.pass }, { headers: { Authorization: "JWT" } });
          config.headers["Authorization"] = `Bearer ${tokenRes.data.access_token}`;
        }
        return config;
      });
      ApiBioTime.instance.interceptors.response.use((response) => {
        return response;
      }, async (error) => {
        const response = error.response;
        const config = error.config;
        if (response.status === 401 && config.headers["Authorization"] && !config._retriyed) {
          const newTokenRes = await ApiBioTime.instance.post("Auth/refresh", {
            token: config.headers["Authorization"],
          });
          config.headers["Authorization"] = `Bearer ${newTokenRes.data.access_token}`;
          config._retriyed = true;
          return Promise.resolve(axiosCore.default(config));
        }
        else {
          return Promise.reject(error);
        }
      });
    }
    return ApiBioTime.instance;
  }
}
